import { useLocation } from 'react-use'
import Section from 'src/components/sections/Section'

import './styles.scss'

import { TextViewDraftJS } from '../common/TextViewDraftJS'
import { TextViewHtml } from '../common/TextViewHtml'
import { CallToAction } from '../common/CallToAction'
import type { TextBlockProps } from './types'

export default function TextBlock(props: TextBlockProps) {
  const { pathname } = useLocation()
  const isOnCampaignPage = pathname?.includes('/campanha/')

  const {
    cta,
    title,
    titleHeadingTag,
    subtitle,
    subtitleHeadingTag,
    fontColor,
    backgroundColor,
    text,
    textFromHtml,
  } = props

  const HeadingTitle = titleHeadingTag ?? 'h2'
  const HeadingSubtitle = subtitleHeadingTag ?? 'h2'

  return (
    <Section
      className="text-block"
      style={{ backgroundColor, color: fontColor }}
    >
      {title && <HeadingTitle>{title.trim()}</HeadingTitle>}
      {subtitle && <HeadingSubtitle>{subtitle.trim()}</HeadingSubtitle>}

      {text.enable && text.body && (
        <div
          className="text-section"
          style={{
            color: text.fontColor,
            textAlign: text.textAlign ?? 'center',
          }}
        >
          <TextViewDraftJS
            text={text.body}
            showSeeMoreButton={!isOnCampaignPage}
          />
        </div>
      )}

      {textFromHtml.enable && <TextViewHtml text={textFromHtml.body} />}

      {cta?.enable && (
        <CallToAction
          link={cta?.linkURL}
          text={cta?.linkText}
          fontColor={cta?.fontColor}
          backgroundColor={cta?.backgroundColor}
        />
      )}
    </Section>
  )
}
